const ukrainian = {
  title: 'ukrainian',
  name: 'UA',
  userMenu: {
    exit: 'Вихiд',
  },
  authForm: {
    signupTitle: 'Реєстрація',
    signinTitle: 'Вхід',
    email: 'Email',
    password: 'Пароль',
    confirmPassword: 'Підтвердіть пароль',
    signupButton: 'Зареєструватися',
    signinButton: 'Увійти',
    signupQuestion: 'Маєте акаунт?',
    signinQuestion: 'Немає акаунту?',
    signupLink: 'Увійти',
    signinLink: 'Зареєструватись',
  },
  sidebarModal: {
    createButton: 'Готово',
    cancelButton: 'Вiдмiна',
  },
  projectsPage: {
    pageTitle: 'Проекти',
    addButton: 'Створити проект',
    projectCollection:
      'Ваша колекція проектів порожня, скористайтесь кнопкою "Створити проект"',
  },
  projectsPageForm: {
    formTitle: 'Створення проекту',
    projectName: 'Назва проекту',
    projectDescription: 'Опис',
  },
  projectPage: {
    addSprintButton: 'Створити спринт',
    addMembersButton: 'Додати людей',
    sprintCollection:
      'Ваша колекція спринтів порожня, скористайтесь кнопкою "Створити спринт"',
  },
  projectPageSidebar: {
    goBack: 'Показати проекти',
    addProjectButton: 'Створити проект',
  },
  projectPageForm: {
    formTitle: 'Створення спринта',
    sprintName: 'Назва спринта',
    prevDays: 'Попереднi днi',
    startDate: 'Дата початку',
    expireDate: 'Дата закiнчення',
    duration: 'Тривалiсть',
  },
  addMembersForm: {
    formTitle: 'Додати людей',
    email: 'Введiть email',
    members: 'Доданi користувачi:',
  },
  sprintPageSidebar: {
    goBack: 'Показати спринти',
    addSprintButton: 'Створити спринт',
  },
  sprintPageHeader: {
    addTaskButton: 'Створити задачу',
    taskName: 'Задача',
    plannedHours: 'Заплановано годин',
    spentHoursPerDay: 'Витрачено год / день',
    spentHoursTotally: 'Витрачено годин',
  },
  sprintPageForm: {
    formTitle: 'Створення задачi',
    taskName: 'Назва задачi',
    plannedHours: 'Заплановано годин',
  },
  sprintPage: {
    taskCollection:
      'Ваша колекція задач порожня, скористайтесь кнопкою "Створити задачу"',
    editProjectName: 'Введiть нову назву',
  },
};

export { ukrainian };
